import {
  type UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import api from '@/axios';
import {
  DELETE_PRODUCTION_DECLARATION_MATERIAL_COMMODITY_ORIGIN_KEY,
  GET_PRODUCTION_DECLARATION_MATERIAL_COMMODITY_ORIGINS_KEY,
} from '@/keys';

type DeleteProductionDeclarationMaterialCommodityOriginVariables = {
  productionDeclarationId: string;
  materialId: string;
  commodityOriginId: string;
  token?: string;
};

async function deleteProductionDeclarationMaterialCommodityOrigin({
  productionDeclarationId,
  materialId,
  commodityOriginId,
  token,
}: DeleteProductionDeclarationMaterialCommodityOriginVariables): Promise<void> {
  await api.delete(
    `/production-declarations/${productionDeclarationId}/materials/${materialId}/commodity-origins/${commodityOriginId}`,
    {
      params: token ? { token } : undefined,
    },
  );
}

export function useDeleteProductionDeclarationMaterialCommodityOrigin(): UseMutationResult<
  void,
  Error,
  DeleteProductionDeclarationMaterialCommodityOriginVariables
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: DELETE_PRODUCTION_DECLARATION_MATERIAL_COMMODITY_ORIGIN_KEY,
    mutationFn: deleteProductionDeclarationMaterialCommodityOrigin,
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: [
          ...GET_PRODUCTION_DECLARATION_MATERIAL_COMMODITY_ORIGINS_KEY,
          variables.productionDeclarationId,
          variables.materialId,
          variables.token ?? '',
        ],
      });
    },
  });
}
